<template>
	<header id="header" class="header" v-bind:class="{pageScrolled: isScrolled}">
		<div class="container">
			<div class="row align-items-center justify-content-between d-flex px-3">
				<div id="logo">
					<a href="/">
						<img id="logo-img" src="@/assets/images/logo.png" v-if="isScrolled" />
						<img id="logo-img" src="@/assets/images/logo-bili.png" v-else />
					</a>
				</div>
				<!-- prijava/registracija -->
				<div v-if="user == null" id="login-container">
					<a href="#" data-toggle="modal" data-target="#login-form">
						<span class="far fa-user-circle"></span>Prijava / Registracija
					</a>
					<!-- <a v-if="isBiz" href="/" class="btn fs-btn white-border">Za Klijente</a>
					<a v-else href="/business" class="btn fs-btn white-border">Za Salone</a> -->
				</div>
				<!-- za vendora -->
				<div v-else-if="user.salon != null" id="login-container">
					<a class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="vendor-menu-btn"><span class="far fa-user-circle"></span>{{user.vendor.username}}</a>
					<auth-drop-down></auth-drop-down>
				</div>
				<!-- za usera -->
				<div v-else id="login-container">
					<a class="dropdown-toggle" data-toggle="dropdown" style="color:white" aria-haspopup="true" aria-expanded="false" id="vendor-menu-btn"><span class="far fa-user-circle"></span>{{user.name}}</a>
					<auth-drop-down2></auth-drop-down2>
				</div>
				<!-- botun -->
				<button id="navbar-toggler" class="navbar-toggler" v-bind:class="{'navbar-light': isScrolled}" @click='setScrolled()' type="button" data-toggle="collapse" data-target="#nav-mob" aria-controls="nav-mob" aria-expanded="false" aria-label="Toggle navigation">
					<span class="fas fa-bars"></span>
				</button>
			</div>
		</div>
		<div class="collapse navbar-collapse" id="nav-mob" name="navMob">
			<div v-if="user != null">
				<authcollapse v-if="user.salon != null"></authcollapse>
				<authcollapse2 v-else></authcollapse2>
			</div>
			<div v-else>
				<div @click="toggle()" class="navbar-nav mt-3">
					<a class="nav-item nav-link" href="#" data-toggle="modal" data-target="#login-form">
						<span class="far fa-user-circle"></span>Prijava / Registracija
					</a>
				</div>
			</div>
		</div>

		<login-modal></login-modal>
		<signup-modal></signup-modal>
		<forgot-modal></forgot-modal>
		<vendor-create-account-modal></vendor-create-account-modal>
	</header>

</template>

<script>
	import loginModal from './login_modal'
	import signupModal from './signup_modal'
	import forgotModal from './forgot-password'
	import vendorCreateAccountModal from './vendor-signup-account'
	import authDropDown from './authdropdown'
	import authDropDown2 from './authdropdown2'
	import authcollapse from './authcollapse'
	import authcollapse2 from './authcollapse2'

	import {
		mapState
	} from 'vuex'

	export default {
		name: 'nav',
		data() {
			return {
				isScrolled: false,
				toggleClicked: false,
				winPos: null
			}
		},
		components: {
			'login-modal': loginModal,
			'signup-modal': signupModal,
			'forgot-modal': forgotModal,
			'vendor-create-account-modal': vendorCreateAccountModal,
			'auth-drop-down': authDropDown,
			'auth-drop-down2': authDropDown2,
			'authcollapse': authcollapse,
			'authcollapse2': authcollapse2,
		},
		methods: {
			logoutNow(e) {
				e.preventDefault();
				this.$store.commit('logout');
				window.location.href = '/';
			},
			toggle() {
				document.getElementById('navbar-toggler').click();
			},
			updateScroll() {
				this.winPos = window.scrollY;
				if (window.scrollY > 50) {
					this.isScrolled = true;
				} else {
					if (this.toggleClicked != true) {
						this.isScrolled = false;
					} else {
						this.isScrolled = true;
					}
				}
			}, setScrolled() {
				this.toggleClicked = !this.toggleClicked;
				if (this.winPos < 50) {
					if (!this.toggleClicked) {
						this.isScrolled = false;
					} else {
						this.isScrolled = true;
					}
				}
			}
		},
		mounted() {
			window.addEventListener('scroll', this.updateScroll);
		},
		created() {
			console.log(this.user);
		},
		computed: {
			...mapState({
				user: (state) => state.user
			}),
			/*isBiz() {
				return window.location.pathname === '/business'
			}*/
		},
	}

</script>